<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >

        <template slot="parent.name" slot-scope="{ item }">
            {{!!item.parent? item.parent.name: ''}}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" size="sm"  @click="onEdit(item)"><i class="fa fa-edit" aria-hidden="true"></i></b-button> 
            <b-button variant="danger" size="sm"  @click="onDelete(item)"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
    export default {
        data(){
            return {
                fields: [
                    {
                        key: 'name',
                        label: 'Cargo',
                        filter: true
                    },
                    {
                        key: 'parent.name',
                        label: 'Supervisión',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },

        props: {
            data: {
                type: Object,
                required: true
            },
            onEdit: {
                type: Function,
                required: true
            },
            onDelete: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },

        methods: {
            onSort(ctx) {
                this.$emit('sort', ctx);
            },
        }
    }
</script>